import React, { Component } from 'react'
import { Row, Card, Badge } from 'react-bootstrap'
import { Icon } from 'semantic-ui-react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import StarIcon from '@material-ui/icons/Star'
import DonutSmallIcon from '@material-ui/icons/DonutSmall'
import './css/project.css'
import project from './json/projects.json'

export class projects extends Component {
  constructor (props) {
    super(props)

    this.state = {
      projectset: []
    }
  }

  componentDidMount () {
    this.setState({
      projectset: project
    })
  }

  render () {
    const myproject = this.state.projectset.map((item) => {
      return (
        <VerticalTimelineElement
          key={item.index}
          className='vertical-timeline-element'
          contentStyle={{ background: 'rgb(0, 0, 0)', color: '#000' }}
          contentArrowStyle={{ borderRight: '10px solid  rgb(0, 0, 0)' }}
          date={item.date}
          iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
          icon={<DonutSmallIcon />}
        >
          <Card>
            <Card.Body style={{ color: 'black' }}>
              <Card.Title><h3>{item.Name}</h3></Card.Title>
              <Card.Subtitle className='mb-2 text-muted'><h4>{item.Project_type}</h4><Badge variant='success'>{item.Prize}</Badge></Card.Subtitle>
              <Card.Text>{item.description}</Card.Text>
              <Card.Link target='_blank' href={item.repository}><Icon name='github' size='big' /></Card.Link>
              <Card.Link target='_blank' href={item.link}><Icon name='linkify' size='big' /></Card.Link>
            </Card.Body>
          </Card>
        </VerticalTimelineElement>
      )
    })

    return (
      <div className='proj'>
        <div id='img3'>
          <div id='project'>
            <div>
              <h1>Welcome to my</h1>
              <Row className='justify-content-center' style={{ color: 'grey' }}>
                <Icon name='compass' size='big' />
                <h3>Projects</h3>
              </Row>
            </div>
          </div>
        </div>
        <div className='container'>
          <VerticalTimeline>
            {myproject}
            <VerticalTimelineElement
              iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
              icon={<StarIcon />}
            />
          </VerticalTimeline>
        </div>
      </div>
    )
  }
}

export default projects
